<template>
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40" @click.self="$emit('close')">
    <div class="bg-white rounded-lg shadow-lg p-8 w-full max-w-[883px] relative mx-4 flex flex-col">
      <button class="absolute top-2 right-2 text-gray-400 hover:text-gray-600 text-xl" @click="$emit('close')">
        <svg class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>

      <div
        v-show="loader"
        class="flex flex-col w-full h-full bg-white  justify-center items-center" 
      >
        <img
          src="@/assets/imgs/tuin_loader_v2.gif"
          alt="cargando..."
          class="w-[500px]"
        >
      </div>

      <div
        v-show="!loader"
      >
        <h2 class="font-semibold text-xl mb-6 text-gray-900">Asignar Propiedad</h2>
      
        <form class="w-full space-y-4">
          <div class="relative overflow-y-auto space-y-4 max-h-96">

            <ListCardComponent
              v-for="(row, index) in list"
              v-show="list.length > 0"
              :key="index"
              :row="row"
              @addProperty="addProperty"
              class="hidden md:flex"
            />

            <GridCardComponent
              v-for="(row, index) in list"
              v-show="list.length > 0"
              :key="index"
              :row="row"
              @addProperty="addProperty"
              class="md:hidden"
            />
            
            <div v-show="list.length == 0" 
              class="flex flex-col items-center justify-center text-center py-8"
            >
              <div 
                class="flex justify-center items-center mb-3"
              >
                <img 
                  src="@/assets/imgs/no_properties_leads.svg" 
                  alt="No tiene una propiedad de interés asignada"
                >
              </div>
              <p 
                class=" text-base text-gray-900 w-full max-w-sm mb-4"
              >
                No tienes propiedades agregadas, te invitamos a que agregues nuevas propiedades
              </p>
              <div class="flex items-end justify-end">
                <button
                  @click="router.push({ name: 'propertyForm' })"
                  class="group text-white hover:bg-tuin_hover bg-tuin-100 flex items-center justify-center gap-2 sm:px-4 sm:py-2.5 p-2.5 rounded-lg  transition text-sm font-medium"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M4 0C4.21217 0 4.41566 0.0842856 4.56569 0.234315C4.71571 0.384344 4.8 0.587827 4.8 0.8V3.2H7.2C7.41217 3.2 7.61566 3.28429 7.76569 3.43431C7.91571 3.58434 8 3.78783 8 4C8 4.21217 7.91571 4.41566 7.76569 4.56569C7.61566 4.71571 7.41217 4.8 7.2 4.8H4.8V7.2C4.8 7.41217 4.71571 7.61566 4.56569 7.76569C4.41566 7.91571 4.21217 8 4 8C3.78783 8 3.58434 7.91571 3.43431 7.76569C3.28429 7.61566 3.2 7.41217 3.2 7.2V4.8H0.8C0.587827 4.8 0.384344 4.71571 0.234315 4.56569C0.0842856 4.41566 0 4.21217 0 4C0 3.78783 0.0842856 3.58434 0.234315 3.43431C0.384344 3.28429 0.587827 3.2 0.8 3.2H3.2V0.8C3.2 0.587827 3.28429 0.384344 3.43431 0.234315C3.58434 0.0842856 3.78783 0 4 0V0Z" class="fill-white"/>
                  </svg>
                  Agregar Propiedad
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script setup>
import { watch, ref, computed } from "vue"; 
import { useStore } from "vuex";
import axios from "axios";
import { useRouter } from 'vue-router';
import ListCardComponent from "@/components/leads/ListCardComponent.vue";
import GridCardComponent from "@/components/leads/GridCardComponent.vue";

const router = useRouter();
const store = useStore();
const emit = defineEmits(['close', 'propertyUpdated']);
const props = defineProps({
  prospectId: {
    type: Number,
    required: true,
    default: 0,
  },
});

let list = ref([]);
let loader = false;
let session = computed(() => store.getters.getUserSession);

async function getPropertiesLead() {
  try {
    let url_link = `${process.env.VUE_APP_API_BASE_URL}/broker/lead/${session.value.id}/properties_list/${props.prospectId}`;

    let options = {
      headers: {
        Authorization: `Bearer ${session.value.token_api}`,
      },
    };

    const response = await axios.get(url_link, options);

    if (response.status == 401) {
      store.dispatch("clearUserSession");
    }

    if (response.status == 200) {
      console.log("Response data:", response.data);
      list.value = response.data.resp;
    }
  } catch (error) {
    console.error("Error fetching data:", error);
  }
  loader = false;
}

async function addProperty({ id, checked }) {
  let property = list.value.find(p => p.id === id);
  if (property) {
    property.is_checked = checked;
  }

  try {
    let url_link = `${process.env.VUE_APP_API_BASE_URL}/broker/lead/${session.value.id}/add-property`;

    let postParams = {
      property_id: id,
      lead_id: props.prospectId,
      is_checked: property.is_checked
    };

    let options = {
      headers: {
        Authorization: `Bearer ${session.value.token_api}`,
      },
    };

    const response = await axios.post(url_link, postParams, options);

    if (response.status == 401) {
      store.dispatch("clearUserSession");
    }

    if (response.status == 200) {
      //showToast("success", response.data.message);
      // Recargar la lista sin mostrar loader
      await getPropertiesLead();
      // Emitir evento al padre para actualizar propiedades
      emit('propertyUpdated', { id, checked });
    }
  } catch (error) {
    console.error("Error fetching data:", error);
  }
  
}

watch(
  () => props,
  (newVal) => {
    if (newVal.prospectId) {
      // Lógica para cargar datos basados en el nuevo ID
      loader = true;
      getPropertiesLead();
    }
  },
  { immediate: true } // Ejecuta el watch inmediatamente al montar el componente
);
</script>
